document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
      // Change the placeholder text of the autocomplete menu
      options.placeholder = "Search Our Products";
      return options;
    });

      algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
        const { html, state } = templateOptions;
        return html`
          <div class="aa-footer">
            <a
              class="aa-SeeAllBtn"
              href="${window.Shopify.routes.root}search?q=${state.query}"
            >
              See results
              (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
            </a>
          </div>
        `;
      });

    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
        // Modify default options, then return them
        const { html, item, components } = templateOptions;
        let isAdvancedLink = false;
        if (item.meta && item.meta.product && item.meta.product.advanced_plp_link) {
          itemLink = item.meta.product.advanced_plp_link;
          isAdvancedLink = true;
        }
        return html`
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        onClick="${() => trackSearchAttribution(item)}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <img
              src="${algoliaShopify.helpers.renderImage(item, 125).src}"
              srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
              sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
              alt="${item.title}"
            />
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: "title" })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
            </div>
            <div class="aa-ItemSku">
              <span class="algolia-sku">
                <strong>SKU:</strong> ${item.sku}
              </span>
            </div>
          </div>
        </div>
      </a>
    `;
      }
    );
});


window.addEventListener('scroll', function() {
  const aaPanel = document.querySelector('.aa-Panel');
  const aaInput = document.querySelector('.aa-Input');

  if (aaPanel) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    aaPanel.style.top = scrollTop + 64 + 'px';

    const aaInputRect = aaInput.getBoundingClientRect();
    const isAaInputVisible = aaInputRect.top >= 0 && aaInputRect.bottom <= window.innerHeight;

    if (isAaInputVisible) {
      aaPanel.style.display = 'block';
    } else {
      aaPanel.style.display = 'none';
    }
  }
});


